// StackingCards.js
import { Link, useNavigate } from "react-router-dom";
import { exploreData } from "../../utils/data";
import "./Stakingcards.css";

const StackingCards = () => {
  const navigate = useNavigate();

  return (
    <main className="stakingcard">
      <ul id="cards">
        {exploreData.map((cardData) => {
          return (
            <li key={cardData.id} className="staking-card-list" id="card_2">
              <div className="landing__explore-card mb-3">
                <div className="row">
                  <div className="col-lg-5">
                    <div>
                      <h6 className="explore__service">
                        {cardData.serviceName}
                      </h6>
                      <h4 className="explore__title">{cardData.cardTitle}</h4>
                      <div className="explore__img-wrap">
                        <img
                          // src={require(`../../image/newLanding/${cardData.cardImg}`)}
                          src={cardData.cardImg}
                          alt="World's No.1 Blockchain Development Company"
                          className="landing__explore-img"
                          loading="lazy"
                        />
                      </div>

                      <p className="explore__content">{cardData.cardContent}</p>
                      <Link to={cardData.cardLink}>
                        <button className="explore__card-btn">
                          {cardData.cardBtn}{" "}
                          <span className="mx-2 right-arr">
                            <i className="fa-solid fa-arrow-right"></i>
                          </span>
                        </button>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-7 explore__top">
                    <div className="landing__explore-card-right-wrap">
                      <div className="row">
                        <div className="col-lg-6 explore-flex-col">
                          {cardData.cardSubContents &&
                            cardData.cardSubContents
                              .slice(
                                0,
                                Math.ceil(cardData.cardSubContents.length / 2)
                              )
                              .map((subContent, index) => (
                                <div
                                  key={index}
                                  className="landing__explore-card-right"
                                  onClick={() =>
                                    navigate(subContent.subCardLink)
                                  }
                                >
                                  <div className="landing__explore-card-content">
                                    <h6>{subContent.subHead}</h6>
                                    <p>{subContent.subContent}</p>
                                  </div>
                                  <div className="landing__explore-card-img-outer">
                                    <div className="landing__explore-card-img-wrap">
                                      <img
                                        src={require(`../../image/newLanding/${subContent.subHeadImg}`)}
                                        alt="World's No.1 Blockchain Development Company"
                                        loading="lazy"
                                      />
                                    </div>
                                  </div>
                                </div>
                              ))}
                        </div>

                        <div className="col-lg-6 explore-flex-col">
                          {cardData.cardSubContents &&
                            cardData.cardSubContents
                              .slice(
                                Math.ceil(cardData.cardSubContents.length / 2)
                              )
                              .map((subContent, index) => (
                                <div
                                  key={index}
                                  className="landing__explore-card-right"
                                  onClick={() =>
                                    navigate(subContent.subCardLink)
                                  }
                                >
                                  <div className="landing__explore-card-content">
                                    <h6>{subContent.subHead}</h6>
                                    <p>{subContent.subContent}</p>
                                  </div>
                                  <div className="landing__explore-card-img-outer">
                                    <div className="landing__explore-card-img-wrap">
                                      <img
                                        src={require(`../../image/newLanding/${subContent.subHeadImg}`)}
                                        alt="World's No.1 Blockchain Development Company"
                                        loading="lazy"
                                      />
                                    </div>
                                  </div>
                                </div>
                              ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </main>
  );
};

export default StackingCards;
